module.exports = __webpack_public_path__ + "static/media/email_segment_used.ae418e43.png";